import "../css/EventsPage.css";
import { lazy, memo, Suspense } from "react";
import { Button } from "react-bootstrap";
import Form from "./Form";

const AutoCarousel = lazy(() => import("./carousel"));
const CommonVideoPlayer = lazy(() => import("../common/common-video-player"));

const BANNER_STYLE: React.CSSProperties = {
  backgroundImage: "url('/Vision-Landing.png')",
  minHeight: "400px",
};

const CAROUSEL_ITEMS: { imageUrl: string }[] = [
  { imageUrl: "/SMBF-26.jpg" },
  { imageUrl: "/SMBF-27.jpg" },
  { imageUrl: "/SMBF-28.jpg" },
  { imageUrl: "/SMBF-29.jpg" },
  { imageUrl: "/SMBF-30.jpg" },
  { imageUrl: "/SMBF-31.jpg" },
  { imageUrl: "/SMBF-32.jpg" },
  { imageUrl: "/SMBF-33.jpg" },
  { imageUrl: "/SMBF-34.jpg" },
  { imageUrl: "/SMBF-35.jpg" },
];

const CAROUSEL_SECTION_STYLE: React.CSSProperties = { minHeight: "300px" };
const SUSPENSE_FALLBACK_STYLE: React.CSSProperties = { minHeight: "200px" };
const VIDEO_SUSPENSE_FALLBACK_STYLE: React.CSSProperties = { minHeight: "300px" };
const TESTIMONIALS_SECTION_STYLE: React.CSSProperties = { minHeight: "400px" };
const SUBMIT_BUTTON_STYLE: React.CSSProperties = {
  backgroundColor: "#3899a2",
  border: "1px solid white",
};

function EventsPage() {
  return (
    <main className="page-content w-100 pt-5 pt-md-5" aria-label="Events page">
      <div
        className="banner py-5 d-flex w-100 flex-column justify-content-between align-items-center"
        style={BANNER_STYLE}
      >
        <div>
          <h1>Events</h1>
          <h4>SMBF Business Networking Events</h4>
        </div>
        <div>
          <h1 className="display-5 fw-semibold px-5">
            Business Networking Events Calendar 2025 Coming Soon
          </h1>
          <p className="fs-3 fw-semibold">
            Be the first to know—register for event updates now
          </p>
        </div>
      </div>
      <div className="m-4 border container-bg p-2 p-md-3 rounded-4">
        <Form />
      </div>
      <div className="carousel-bg px-2 pb-5" style={CAROUSEL_SECTION_STYLE}>
        <div className="text-center text-white py-5">
          <h1>Previous Events</h1>
        </div>
        <Suspense fallback={<div style={SUSPENSE_FALLBACK_STYLE} />}>
          <AutoCarousel items={CAROUSEL_ITEMS} />
        </Suspense>
      </div>
      <div className="container py-4">
        <div className="row gap-4 gap-md-0">
          <div className="col-md-5 d-flex justify-content-center align-items-center">
            <img
              className="img-fluid w-100 image h-100 rounded-4"
              src="/SMBF-15.png"
              alt="SMBF Events"
              width={600}
              height={400}
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className="col-md-7 d-flex justify-content-center flex-column">
            <h2>SMBF Events</h2>
            <p>
              Throughout the year, SMBF holds a wide variety of events ranging
              from our very popular monthly business networking dinners,
              seminars on various topics, Mastermind groups for entrepreneurs,
              headed by highly successful individuals from amongst SMBF Member
              Directory, Trade Fairs across the UK, Careers Fairs, and many
              more.
            </p>
            <p>
              SMBF events serve the singular purpose of benefiting the Muslim
              Business community through multiple avenues, including, but not
              limited to; education, awareness and implementation of ethical
              business practices, aiding in business development, teaching
              Islamic ethics, and most importantly, the establishment and growth
              of a Global Muslim Network.
            </p>
          </div>
        </div>
      </div>
      <div className="container py-4">
        <div className="row gap-4 gap-md-0">
          <div className="col-md-7 d-flex justify-content-center flex-column">
            <h2>Business & Professional Networking Dinners</h2>
            <p>
              SMBF hold regular Muslim business networking dinners exclusive to
              Muslim Businesses & Professionals who are SMBF Members. Attendees
              have the opportunity to network, invest, expand their business and
              engage with high-value businesses and professionals.{" "}
            </p>
            <p>
              Keynote speakers have included CEO’s, Parliamentary advisors,
              sales experts, property experts, Tech CEO’s and a wide variety of
              high-value individuals from the Muslim Business Community. Our
              dinners provide a unique opportunity for you to connect with
              talented individuals opening doors for exciting opportunities, all
              whilst adhering to Islamic business ethics and principles.{" "}
            </p>
          </div>
          <div className="col-md-5 d-flex justify-content-center align-items-center">
            <img
              className="img-fluid w-100 image h-100 rounded-4"
              src="/SMBF-WebPic-1.png"
              alt="SMBF Business and Professional Networking"
              width={600}
              height={400}
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>
      <div className="carousel-bg p-3 p-md-5" style={TESTIMONIALS_SECTION_STYLE}>
        <div className="row gap-2 py-md-5 gap-md-0">
          <div className="col-md-4">
            <div className=" text-white d-flex align-items-center justify-content-center h-100">
              <h1 className="display-4 fw-bold">Event Testimonials</h1>
            </div>
          </div>
          <div className="col-md-4">
            <Suspense fallback={<div style={VIDEO_SUSPENSE_FALLBACK_STYLE} />}>
              <CommonVideoPlayer
                backgroundImage="url(Video-bg-1.png)"
                src="SMBF-video-2.mp4"
              />
            </Suspense>
          </div>
          <div className="col-md-4">
            <Suspense fallback={<div style={VIDEO_SUSPENSE_FALLBACK_STYLE} />}>
              <CommonVideoPlayer
                backgroundImage="url(Video-bg-2.png)"
                src="SMBF-video-1.mp4"
              />
            </Suspense>
          </div>
        </div>
      </div>
      <div className="m-4 border mailing-container-bg p-2 p-md-3 rounded-4">
        <div className="row p-2 py-md-5">
          <div className="col-md-6 px-md-5 px-2 text-white">
            <h1>Join our events mailing list</h1>
            <p className="fs-4">Get the latest events direct to your inbox</p>
          </div>
          <div className="col-md-6">
            <form
              className="d-flex px-md-5 px-2 flex-column justify-content-center gap-2"
              aria-label="Join events mailing list"
            >
              <div className="d-flex gap-2">
                <input
                  type="text"
                  className="form-control rounded-pill px-4"
                  placeholder="Full Name"
                  aria-label="Full Name"
                />
                <input
                  type="email"
                  className="form-control rounded-pill px-4"
                  placeholder="Email Address"
                  aria-label="Email Address"
                />
              </div>
              <Button
                type="submit"
                className="w-100 rounded-pill fw-bold text-white"
                style={SUBMIT_BUTTON_STYLE}
              >
                SEND
              </Button>
            </form>
          </div>
        </div>
      </div>
    </main>
  );
}

EventsPage.displayName = "EventsPage";

export default memo(EventsPage);
